// This file contains all supported regions
// We only allow a subset of regions to be "deployable" in PROD
// These are marked in the toDisplayRegion

export enum RRegion {
    CANADA = 'CACentral1',
    NORTH_VIRGINIA = 'USEast1',
    OHIO = 'USEast2',
    OREGON = 'USWest2',
    GERMANY = 'EUCentral1',
    SWITZERLAND = 'EUCentral2',
    IRELAND = 'EUWest1',
    LONDON = 'EUWest2',
    PARIS = 'EUWest3',
    STOCKHOLM = 'EUNorth1',
    SINGAPORE = 'APSoutheast1',
    SYDNEY = 'APSoutheast2',
    MALAYSIA = 'APSoutheast5',
    THAILAND = 'APSoutheast7',
    MUMBAI = 'APSouth1',
    BAHRAIN = 'MESouth1',
    HONG_KONG = 'APEast1',
    CAPE_TOWN = 'AFSouth1',
    MILAN = 'EUSouth1',
    SPAIN = 'EUSouth2',
    SAO_PAULO = 'SAEast1',
    UAE = 'MECentral1',
    MEXICO = 'MXCentral1',
    ISRAEL = 'ILCentral1'
}

export class RegionDisplay {
    constructor(public key: string, public display: string, public isProdReady: boolean = true) {
    }

}

// Create a Map for displaying the RRegion values
export const toDisplayRegion: Map<RRegion, RegionDisplay> = new Map<RRegion, RegionDisplay>([
    [RRegion.CANADA, new RegionDisplay(RRegion.CANADA, 'Canada (Central)')],
    [RRegion.NORTH_VIRGINIA, new RegionDisplay(RRegion.NORTH_VIRGINIA, 'US East (North Virginia)')],
    [RRegion.OHIO, new RegionDisplay(RRegion.OHIO, 'US East (Ohio)')],
    [RRegion.OREGON, new RegionDisplay(RRegion.OREGON, 'US West (Oregon)')],
    [RRegion.GERMANY, new RegionDisplay(RRegion.GERMANY, 'Europe (Germany)')],
    [RRegion.IRELAND, new RegionDisplay(RRegion.IRELAND, 'Europe (Ireland)')],
    [RRegion.LONDON, new RegionDisplay(RRegion.LONDON, 'Europe (UK)')],
    [RRegion.PARIS, new RegionDisplay(RRegion.PARIS, 'Europe (France)')],
    [RRegion.STOCKHOLM, new RegionDisplay(RRegion.STOCKHOLM, 'Europe (Sweden)')],
    [RRegion.MILAN, new RegionDisplay(RRegion.MILAN, 'Europe (Italy)')],
    [RRegion.SYDNEY, new RegionDisplay(RRegion.SYDNEY, 'Asia Pacific (Australia)')],
    [RRegion.SINGAPORE, new RegionDisplay(RRegion.SINGAPORE, 'Asia Pacific (Singapore)')],
    [RRegion.MUMBAI, new RegionDisplay(RRegion.MUMBAI, 'Asia Pacific (India)')],

    // Region B regions
    [RRegion.CAPE_TOWN, new RegionDisplay(RRegion.CAPE_TOWN, 'Africa (South Africa)')],
    [RRegion.HONG_KONG, new RegionDisplay(RRegion.HONG_KONG, 'Asia Pacific (Hong Kong)')],
    [RRegion.SAO_PAULO, new RegionDisplay(RRegion.SAO_PAULO, 'South America (Brazil)')],
    [RRegion.SWITZERLAND, new RegionDisplay(RRegion.SWITZERLAND, 'Europe (Switzerland)')],

    // Region BAHRAIN (me-south-1) has been removed, due to on going issues
    // Region UAE (me-central-1) has been removed, due to on going issues
    [RRegion.BAHRAIN, new RegionDisplay(RRegion.BAHRAIN, 'Middle East (Bahrain)', false)],
    [RRegion.UAE, new RegionDisplay(RRegion.UAE, 'Middle East (UAE)', false)],

    //
    // NOTE: The following are not allowed in PROD environment.
    //       Still checking on costs, COGS or EC2 instance availability.
    //
    [RRegion.SPAIN, new RegionDisplay(RRegion.SPAIN, 'Europe (Spain)', false)],
    [RRegion.MEXICO, new RegionDisplay(RRegion.MEXICO, 'Central America (Mexico)', false)],
    [RRegion.MALAYSIA, new RegionDisplay(RRegion.MALAYSIA, 'Asia Pacific (Malaysia)', false)],
    [RRegion.THAILAND, new RegionDisplay(RRegion.THAILAND, 'Asia Pacific (Thailand)', false)],
    [RRegion.ISRAEL, new RegionDisplay(RRegion.ISRAEL, 'Middle East (Israel)', false)]
]);
